export const artifactsLabelMap: any = {
  crf: "Datasheet",
  screener: "Screening",
  econsent: "Econsent",
};

export const artifactsTypes = [
  {
    key: "crf",
    label: "Datasheet",
  },
  {
    key: "screener",
    label: "Screening",
  },
  {
    key: "econsent",
    label: "Econsent",
  },
];
